var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","color":"transparent"}},[_c('v-tabs',_vm._l((_vm.paths),function(path,i){return _c('v-tab',{key:i,attrs:{"link":"","to":path.url}},[_vm._v(_vm._s(path.name))])}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }